import employeeOnboarding from 'api/employeeOnboarding';
import { useUserId } from 'components/EmployeeDetails/BankAccountDetails/hooks/useUserId';
import { GET_STATUTORY_CONTRIBUTIONS_DATA } from '../data';
import { useQuery } from 'react-query';

export const useEligiblePtStates = () => {
  const userId = useUserId();

  const queryResponse = useQuery({
    queryKey: [GET_STATUTORY_CONTRIBUTIONS_DATA, userId],
    queryFn: () => employeeOnboarding.fetchEmployeeStatutorySettings(userId!),
    select: (statutorySettings) => {
      return {
        eligibleStates: statutorySettings.pt_eligible_states,
      };
    },
    enabled: !!userId,
    refetchOnMount: false,
  });

  return queryResponse;
};
